@if (error) {
	<admonition-box class="mb2" type="error" [content]="error" header="Error" [closable]="true" (close)="error = ''"></admonition-box>
}

<div fxLayout="column" fxLayoutGap="16px">
	<p class="h2">{{ headline }}</p>
	<div>
		{{ description }}
	</div>
	<div fxLayout="column">
		<mcm-customer-select #tenantForm></mcm-customer-select>
	</div>
	<div fxLayout="row" fxLayoutAlign="end center" fxLayoutGap="8px">
		@if (isUpdating) {
			<mat-spinner [diameter]="32"></mat-spinner>
		}
		<button mat-raised-button (click)="cancel()" [disabled]="isUpdating">Cancel</button>
		<button mat-raised-button color="primary" (click)="update(tenantForm)" [disabled]="!tenantForm.value || isUpdating">Update</button>
	</div>
</div>
